<top-navig [display]="true" [displayLogo]="false" title="Contactez-nous"></top-navig>
<div class="contact-us" [class.p-95]="ourApp">
  <div class="container heading">
    <div class="contact-form" [@fade]="true">
      <div class="row">
        <div class="col-sm-12">
          <div class="contact-info wow fadeInUp animated">
            <div class="footer_column contact">
              <hr class="half_space">
              <p> <img src="assets/imgs/restaurant.svg" style="margin-right: 6px;" width="32px" [alt]="pdv?.name">
                {{pdv?.name}}
              </p>
              <p class="address">
                <i class="flaticon-pin"></i>
                <a #maplink href="#" target="_blank"> {{pdv?.address}}</a>
              </p>
              <p class="phone">
                <i class="flaticon-phone-on-circle"></i>
                <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
              </p>
              <p class="email" *ngIf="pdv?.emailContact">
                <i class="flaticon-arroba"></i>
                <a href="mailto:{{pdv?.emailContact}}">
                  <span>
                    {{pdv?.emailContact}}
                  </span>
                </a>
              </p>
              <p class="phone" *ngIf="pdv?.facebook">
                <i class="flaticon-facebook"></i>
                <a href="{{pdv?.facebook }}" target="_blank">
                  Contactez nous sur facebook
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>